

import React from 'react';
import Layout from "../components/Layout";


import { Cabecera } from '../components'
const SolicitudGrande = () => {

    return (
        <>
            <Layout />
            <Cabecera />
        </>
    )
}

export default SolicitudGrande;


// Compare this snippet from src/pages/VerificacionTelefonica.js: